export default "__VITE_ASSET__CVWLSJ39__"